import { Link } from 'react-router-dom';

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  icon?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeader({
  title,
  subtitle,
  icon = 'ri-fire-line',
  moreTo,
  moreLabel = '查看更多',
}: SectionHeaderProps) {
  return (
    <div className="flex items-end justify-between mb-5">
      <div className="flex items-center gap-2">
        <span className="w-9 h-9 rounded-md bg-primary-500/15 text-primary-500 flex items-center justify-center">
          <i className={`${icon} text-lg`}></i>
        </span>
        <div>
          <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">{title}</h2>
          {subtitle && <p className="mt-0.5 text-sm text-foreground-500">{subtitle}</p>}
        </div>
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="flex items-center gap-1 text-sm text-foreground-500 hover:text-primary-500 cursor-pointer whitespace-nowrap transition-colors"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      )}
    </div>
  );
}